<div [@routerTransition]>

  <div class="col-sm-12" *ngIf='IsSetAccessRights'>

    <professionalreference [ActorCode]='ActorCode'
                           [CanEdit]='CanEditReferences' [CanShow]='CanShowReferences'
                           *ngIf="ActorCode >0"></professionalreference>

  </div>
</div>
